import { render, staticRenderFns } from "./headerMenu.vue?vue&type=template&id=5bd23b2a&scoped=true"
import script from "./headerMenu.vue?vue&type=script&lang=js"
export * from "./headerMenu.vue?vue&type=script&lang=js"
import style0 from "./headerMenu.vue?vue&type=style&index=0&id=5bd23b2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd23b2a",
  null
  
)

/* custom blocks */
import block0 from "./headerMenu.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports